import { UPDATE_TEMPORARY_DECREE_MUTATION } from "@/services/web/api-decree.const";
import { UpdateTemporaryDecreeInput } from "@/types/gql/graphql";
import { useTrackedMutation } from "@/hooks/apollo-insights-hooks";

export const useTemporaryDecree = (refetchDecree: () => void) => {
  const [updateTemporaryDecree] = useTrackedMutation(UPDATE_TEMPORARY_DECREE_MUTATION);

  const updateTemporaryDecreeCategory = async (input: UpdateTemporaryDecreeInput) => {
    await updateTemporaryDecree({
      variables: { updateDecreeInput: input },
      onCompleted: () => {
        refetchDecree();
      },
    });
  };

  return {
    updateTemporaryDecreeCategory,
  };
};
